export default __webpack_public_path__ + "static/media/mmcookie.b6eff7d9.png";